import { createSelector } from '@reduxjs/toolkit';
import { selectConstructionYear } from 'shared/selectors/jsonQuery';

export const selectConstructionYearFilter = createSelector(selectConstructionYear, ({ gte = null, lte = null }) => ({
  value: { min: gte, max: lte },
  min: 1336,
  max: 2038,
}));
